// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2ty2f","filesListContainer":"PosDisputesFiles_filesListContainer__2bdCE","filesButton":"PosDisputesFiles_filesButton__3y4JP"};